export default "__VITE_ASSET__DvxYecaP__"